import React, { FC, ReactElement } from 'react'
import styles from './NameInscriptionContent.module.css'
import classNames from 'classnames'
import { Inscription } from '@/utils/types/inscription'

const NameInscriptionContent: FC<{
	inscription: Inscription
	// notice className is used on root & image, this is to get the same sizing
	className?: string
	textClassName?: string
	smallCard?: boolean
}> = (props): ReactElement => {
	const { inscription } = props

	const fontSize = props?.smallCard ? 'text-xxs' : 'text-lg'
	const name = props?.smallCard ? inscription?.meta?.name?.slice(0, 10) : inscription?.meta?.name

	return (
		<div className={classNames({ [(props?.className as any)]: !!props?.className }, styles.root)}>
			<img
				className={classNames(styles.background, {
					[(props?.className as any)]: !!props?.className
				})}
				src="/brc20-background.jpg"
				alt=""
			/>
			<div className={styles.contentContainer}>
				<p className={classNames(fontSize, 'regular', styles.content)}>{name}</p>
			</div>
		</div>
	)
}

export default NameInscriptionContent
